import React from 'react'
import Hero from '../components/homepage/Hero'
import Company from '../components/homepage/Company'
import Highlights from '../components/homepage/Highlights'
import ProjectOverview from '../components/homepage/ProjectOverview'
import CTA from '../components/homepage/CTA'
import MapSection from '../components/contactpage/MapSection'

const HomePage = () => {
  return (
    <div>
      <div id="home">
        <Hero />
      </div>
      <div id="company">
        <Company />
      </div>
      <ProjectOverview />
      <div id="highlights">
        <Highlights />
      </div>
      <div id="location" className="my-16 mx-5">
        <MapSection 
          title="Location"
          showDirectionsButton={true}
        />
      </div>
      <CTA />
      {/* <Testimonials /> */}
    </div>
  )
}

export default HomePage